import { Logo } from "@/components/Logo";
import { useGoogleCallback } from "@/hooks/useGoogleCallback";

export { startGoogleLogin } from "@/lib/googleAuth";

export const AuthCallback = () => {
  useGoogleCallback();
  return (
    <div className="min-h-screen bg-ink text-slate-50 flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <Logo size={40} />
      <p className="font-mono-ui text-[11px] uppercase tracking-[0.3em] text-slate-400" data-testid="google-auth-progress" role="status">Connexion en cours…</p>
    </div>
  );
};